import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
import { QuestionType } from '@module/form';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { jsx as _jsx } from "react/jsx-runtime";
export var useQuestionPreviewHook = function useQuestionPreviewHook(_ref) {
  var question = _ref.question,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      onPin = _ref.onPin,
      onCancelPin = _ref.onCancelPin,
      pinnedQuestionId = _ref.pinnedQuestionId,
      _ref$isEditable = _ref.isEditable,
      isEditable = _ref$isEditable === void 0 ? false : _ref$isEditable,
      onEditRequest = _ref.onEditRequest,
      onDeleteQuestion = _ref.onDeleteQuestion,
      onSelectQuestion = _ref.onSelectQuestion,
      customLabels = _ref.customLabels,
      answers = _ref.answers,
      onAnswer = _ref.onAnswer,
      _ref$hideExplanation = _ref.hideExplanation,
      hideExplanation = _ref$hideExplanation === void 0 ? false : _ref$hideExplanation,
      _ref$isShowCorrectAns = _ref.isShowCorrectAnswer,
      isShowCorrectAnswer = _ref$isShowCorrectAns === void 0 ? true : _ref$isShowCorrectAns,
      audioPlayerLabels = _ref.audioPlayerLabels,
      speakingLabel = _ref.speakingLabel,
      questionDescriptionLabel = _ref.questionDescriptionLabel;

  var _useTranslation = useTranslation('common'),
      translation = _useTranslation.t;

  var _useTranslation2 = useTranslation('form'),
      formTranslation = _useTranslation2.t; // Base registry


  var baseRegistry = useMemo(function () {
    return {
      actions: {
        onPinQuestion: onPin,
        onCancelPin: onCancelPin,
        onEditRequest: onEditRequest,
        onDeleteQuestion: onDeleteQuestion,
        onSelectQuestion: onSelectQuestion
      },
      states: {
        isSelected: isSelected,
        isEditable: isEditable,
        pinnedQuestionId: pinnedQuestionId,
        readonly: true,
        hideExplanation: hideExplanation,
        isShowCorrectAnswer: isShowCorrectAnswer,
        audioPlayerLabels: audioPlayerLabels,
        label: _objectSpread(_objectSpread({
          audio: translation('audio') || formTranslation('audio') || 'Âm Thanh',
          multipleChoice: formTranslation('multipleChoiceQuestion') || 'Multiple Choice',
          singleChoice: formTranslation('singleChoiceQuestion') || 'Single Choice',
          fillInBlank: formTranslation('fillInBlankQuestion') || 'Fill in Blank',
          matching: formTranslation('matchingQuestion') || 'Matching',
          essay: formTranslation('essay') || 'Essay',
          explanation: translation('explanation') || 'Explanation',
          "delete": translation('delete') || 'Delete',
          confirmDeleteQuestion: translation('confirmDeleteQuestion') || 'Confirm Delete Question',
          doYouWantToContinueDoingThis: translation('doYouWantToContinueDoingThis') || 'Do you want to continue doing this?',
          confirm: translation('confirm') || 'Confirm',
          cancel: translation('cancel') || 'Cancel',
          score: translation('score') || 'Score',
          question: translation('question') || 'Question',
          edit: translation('edit') || 'Edit',
          readMore: translation('seeMore'),
          readLess: translation('seeLess')
        }, questionDescriptionLabel), customLabels),
        icon: {
          star: /*#__PURE__*/_jsx(Image, {
            src: "/icons/star.svg",
            width: 14,
            height: 14,
            alt: "star"
          }),
          pointFocus: /*#__PURE__*/_jsx(Image, {
            src: "/icons/point-focus.svg",
            width: 14,
            height: 14,
            alt: "point-focus"
          }),
          lightBulb: /*#__PURE__*/_jsx(Image, {
            src: "/icons/light-bulb.svg",
            width: 20,
            height: 20,
            alt: "light-bulb"
          }),
          pin: /*#__PURE__*/_jsx(Image, {
            src: "/icons/pin.svg",
            alt: "pin",
            width: 20,
            height: 20
          })
        }
      }
    };
  }, [isSelected, isEditable, pinnedQuestionId, onPin, onCancelPin, onEditRequest, onDeleteQuestion, onSelectQuestion, translation, formTranslation, customLabels, questionDescriptionLabel, hideExplanation, isShowCorrectAnswer, audioPlayerLabels]);

  switch (question.type) {
    case QuestionType.SingleChoice:
      {
        return {
          actions: _objectSpread({}, baseRegistry.actions),
          states: _objectSpread(_objectSpread({}, baseRegistry.states), {}, {
            singleChoiceLabel: {
              answers: translation('answers') || 'Answers'
            }
          })
        };
      }

    case QuestionType.MultipleChoice:
      {
        return {
          actions: _objectSpread({}, baseRegistry.actions),
          states: _objectSpread(_objectSpread({}, baseRegistry.states), {}, {
            multipleChoiceLabel: {
              answers: translation('answers') || 'Answers'
            }
          })
        };
      }

    case QuestionType.FillInBlank:
      {
        return {
          actions: _objectSpread(_objectSpread({}, baseRegistry.actions), {}, {
            onAnswer: onAnswer
          }),
          states: _objectSpread(_objectSpread({}, baseRegistry.states), {}, {
            answers: answers
          })
        };
      }

    case QuestionType.Matching:
      {
        return {
          actions: _objectSpread({}, baseRegistry.actions),
          states: _objectSpread(_objectSpread({}, baseRegistry.states), {}, {
            matchingLabel: {
              answers: translation('answers') || 'Answers'
            }
          })
        };
      }

    case QuestionType.Speaking:
      {
        var speakingQuestion = question;
        return {
          actions: _objectSpread({}, baseRegistry.actions),
          states: _objectSpread(_objectSpread({}, baseRegistry.states), {}, {
            readonly: true,
            speakingSettings: speakingQuestion.speakingSettings,
            speakingLabel: speakingLabel
          })
        };
      }

    case QuestionType.Essay:
    default:
      {
        return baseRegistry;
      }
  }
};